import React from "react";
import { FaFacebookF, FaGithub, FaLinkedinIn, FaPhone, FaRegEnvelopeOpen, FaSkype, FaTwitter } from "react-icons/fa";
import footerLogo from '../../../../src/images/hafizLogo.png'
import './Footer.css';
import devSignature from '../../../../src/images/signature.jpg'

const Footer = () => {
  return (
    <footer style={{marginTop:'80px', background:'linear-gradient(to right, #e9e4f0, #e9e4f0)', marginBottom:'80px', borderRadius:'20px'}}>
      <div className="container grid grid-cols-1 md:grid-cols-2 py-8 px-8">
       <div>
         <div style={{display:'flex', alignItems:'center'}}>
         <img style={{width:'30%', height:'35%'}} src={footerLogo} alt="" />
         <span style={{fontFamily: 'Oswald, sans-serif', fontSize:'26px', fontWeight:'bold', marginLeft:'-5px', textDecoration:'underLine', letterSpacing:'.5px'}}>Hafizur</span>
         </div>
         <div style={{marginLeft:'20px'}}>
         <div style={{marginTop:'20px'}}>
           <p style={{display:'flex', alignItems:'center', fontSize:'15px'}}><FaPhone /> <span style={{marginLeft:'8px'}}>+880 195 064 6560</span> </p>
           <p style={{display:'flex', alignItems:'center', fontSize:'15px', marginTop:'6px'}}><FaRegEnvelopeOpen /> <span style={{marginLeft:'8px'}}>hafizurrahman.jr@gmail.com</span> </p>
           
         </div>
         <div style={{display:'flex', marginTop:'16px'}}>
        <a href="https://web.facebook.com/okshihafiz" style={{marginRight:'14px'}}> <FaFacebookF /></a>
         <a href="https://github.com/okshihafiz" style={{marginRight:'14px'}}><FaGithub /></a>
         <a href="https://www.linkedin.com/in/hafizur-rahman-jr/" style={{marginRight:'14px'}}><FaLinkedinIn /></a>
         <a href="https://twitter.com/hafizur_jr" style={{marginRight:'14px'}}><FaTwitter /></a>
         <a href="https://join.skype.com/invite/uwPI61pfWsxA" style={{marginRight:'14px'}}><FaSkype /></a>

         </div>
         </div>
       </div>
       
       <div>
         <p style={{textAlign:'justify', marginTop:'20px'}}>As a Front End daveloper, take your data and convert it into something visually appealing for the rest of us to enjoyably digest.
        The core focuses on the look and feel of the site, along with its functionality </p>
        {/* <img   src={devSignature} alt="" /> */}
         
        <div style={{marginTop:'20px'}}>
         <input className="laterBox" type="email" name="" placeholder="Your Email" id="" />
         <button className="laterBtn">News Later</button>
       </div>
       </div>
      </div>
    </footer>
  );
};

export default Footer;
